import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import { DateUtil } from '../utils';

/**
 * [Model] VersionSetItem
 */
var VersionSetItem = /*#__PURE__*/function () {
  function VersionSetItem() {
    _classCallCheck(this, VersionSetItem);
  }
  return _createClass(VersionSetItem, null, [{
    key: "parseV3",
    value:
    /**
     * Parse camel case data
     */
    function parseV3(data) {
      var rowData = data || {};
      var entity = new VersionSetItem();
      entity.collection = rowData.collection;
      entity.createdAt = DateUtil.dateStringReformat(rowData.createdAt);
      entity.createdBy = rowData.createdBy;
      entity.createdByName = rowData.createdByName;
      entity.deleted = rowData.deleted;
      entity.id = rowData.id;
      entity.issuanceDate = DateUtil.trimTimezoneAndToLocal(rowData.issuanceDate);
      entity.name = rowData.name;
      entity.updatedAt = DateUtil.dateStringReformat(rowData.updatedAt);
      entity.updatedBy = rowData.updatedBy;
      entity.updatedByName = rowData.updatedByName;
      return entity;
    }
  }]);
}();
export { VersionSetItem as default };